// extracted by mini-css-extract-plugin
export default {"container":"Partners_container__khHAW","headerWrap":"Partners_headerWrap__-YzrW","collaborate":"Partners_collaborate__szZ5k","partners":"Partners_partners__KF97T"};